import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'

// "use strict";

//Documentos

  const DetDocum = ({elemento}) => {
    return(
      <tr className=''>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipo}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuario}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cedula}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ciudad}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.telefono}</td>          
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cargo}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.gestionaHallazgos}</td>
      </tr>
    )
  };

const ListaDocum = ({list, tipoCargue}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetDocum elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class CargUsu2 extends React.Component {
  state={listDocum: [], checked: true, permiteUpdate: true, confirmaAct: false, open: false, errors: []
}

  handleChange = async (ev) => {
    const updState = (listDocum) => {
      this.setState({listDocum, errors: []})
    };
// console.log(this.props.tipoCargue)
    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        let archcsv = ""
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result

          //asignar los datos del archivo a archivo
        let archivo = archcsv.toString()

        let lines = archivo.split(/\n/)
        let numDoc = 0, linea = 0, listDocum = []
          lines.forEach(line => {
            if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
              linea += 1
              //crear array de campos para cada linea
              let campos = line.split(";")
              let tipo = campos[0].replace(/^\s+|\s+$/g, '')
              let nombreUsuario = campos[1]
              let descrEmpresa = campos[2]
              let cedula = campos[3].replace(/^\s+|\s+$/g, '')
              let ciudad = campos[4]
              let telefono = campos[5].replace(/^\s+|\s+$/g, '')
              let cargo = campos[6]
              let estado = campos[7]
              let gestionaHallazgos = campos[8].replace(/^\s+|\s+$/g, '')

              listDocum.push({tipo, nombreUsuario, descrEmpresa, cedula, 
                ciudad, telefono, cargo, estado, gestionaHallazgos})
            }
            numDoc += 1
          })
          listDocum = _.orderBy(listDocum, ['nombreUsuario'], ['asc'])
          updState(listDocum)
        }  
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
        this.setState({checked: checkTieneEncab})
      }else{
        this.setState({listDocum: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listDocum)=>{
    console.log(listDocum)
    document.body.style.cursor = 'wait'

    let usuarios = [], empresas = []
    let {data} = await this.props.allUsuarios.refetch()
    usuarios = await data.allUsuarios
    if(this.props.allEmpresa){
      let {data} = await this.props.allEmpresa.refetch()
      empresas = await data.allEmpresa
    }
      document.body.style.cursor = 'wait'
      let errors = []
      if(listDocum.length===0){
        errors.push({path: "Cargue", message: "No hay información"});
      }

      this.setState({errors})
      if(errors.length===0){
        listDocum.forEach(async (elemento, i) => {
          let tipo = elemento.tipo, nombreUsuario = elemento.nombreUsuario
          let descrEmpresa = elemento.descrEmpresa?elemento.descrEmpresa:''
          let cedula = elemento.cedula?elemento.cedula:"", ciudad = elemento.ciudad?elemento.ciudad:''
          let telefono = elemento.telefono?elemento.telefono:""
          let cargo = elemento.cargo?elemento.cargo:''
          let estado = elemento.estado?elemento.estado:"Activo"
          let gestionaHallazgos = elemento.gestionaHallazgos?elemento.gestionaHallazgos:'No'

          if(!nombreUsuario){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del nombre de usuario`});
          }
          if(!descrEmpresa){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la empresa`});
          }
          if(estado!=="Activo" && estado!=="Inactivo"){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} El estado no es valido`});
          }
          if(gestionaHallazgos!=="Si" && gestionaHallazgos!=="No"){
            console.log(gestionaHallazgos)
            errors.push({path: "Cargue", message: `Línea: ${i + 1} El campo Gestiona hallazgo no es valido: ${gestionaHallazgos}`});
          }
          if(nombreUsuario){
            let indexUsu = usuarios.findIndex( usuario => usuario.nombreUsuario===nombreUsuario)
            if(indexUsu===-1){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} USUARIO NO EXISTE: ${nombreUsuario}`});
            }
            if(descrEmpresa && descrEmpresa!=='Todas' && descrEmpresa!=='Todas...'){
              let indexEmp = empresas.findIndex( empresa => empresa.descrEmpresa===descrEmpresa )
              if(indexEmp===-1){
                errors.push({path: i + " Cargue", message: `Línea: ${i + 1} => La empresa ${descrEmpresa} no ha sido creada`});
              }
            }else{
              if(descrEmpresa==='Todas'){
                descrEmpresa='Todas...'
              }
            }
          }
        })
        if(errors.length>0){
          this.setState({errors})
        }else{
          listDocum.forEach(async (elemento, i) => {

            const argsUpd = {
              tipoAct: 'EditarUsuMasivo',
              tipo: elemento.tipo, 
              nombreUsuario: elemento.nombreUsuario,
              descrEmpresa: elemento.descrEmpresa,
              cedula: elemento.cedula?elemento.cedula:'',
              ciudad: elemento.ciudad?elemento.ciudad:'',
              telefono: elemento.telefono?elemento.telefono:"", 
              cargo: elemento.cargo?elemento.cargo:'',
              estado: elemento.estado,
              gestionaHallazgos: elemento.gestionaHallazgos,
            }
            const response = await this.props.editUsuario({
              variables: argsUpd
            });
            const {errors, success} = response.data.editUsuario;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
            }
            
            this.setState({listDocum: []})
            
          })
        }

        if(errors.length===0){
          alert("!! Carga exitosa !!")
        }
      }
    document.body.style.cursor = 'default'
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  // async componentDidUpdate(prevProps){

  // }

  render(){
    const {listDocum, checked, permiteUpdate, confirmaAct, open, errors} = this.state;
    let mensaje = "PROCESAR ARCHIVO"
    let imgIcon = "images/archivo_32.png"
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let tit1 = "Edición masiva de usuarios"
    let tit2 = "Procesar archivo de usuarios"
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            {tit1}
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listDocum):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                    <div className="row container">
                        <div className="column" style={{width: '100%'}}>
                          <h1 style={{color: '#2C7744'}}>{tit2}</h1>
                        </div>
                    </div>
                </div>
                <hr></hr>
                <hr></hr>
                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <br/>
                <hr></hr>
                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total documentos:&nbsp;
                  {listDocum.length}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                    errors.length?<Message negative header="Los siguientes errores:"
                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
                <div style={{height: '40em', overflow: 'auto'}}>
                  <table id="tablaDocum" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Nombre</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cédula</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ciudad</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Teléfono</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cargo</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Gestiona hallazgos</th>
                      </tr>
                    </thead>
                    <ListaDocum list={listDocum} />
                  </table>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )    
  }
}

export default compose(
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),

  graphql(queries.mutation.editUsuario, {name:'editUsuario'}),
  
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(CargUsu2)
